<template>
  <mask-matrix
    v-if="available && !!current.previewMask && !!current.previewMask.src"
    :preview="current"
    :scale="scale"
    :preview-width="previewWidth"
    :preview-height="previewHeight"
  >
    <point
      :x="(current.stampX1 + current.positionX) * scale"
      :y="(current.stampY1 + current.positionY) * scale"
      @x="(v) => (current.stampX1 = (v - current.positionX) / scale)"
      @y="(v) => (current.stampY1 = (v - current.positionY) / scale)"
    />
    <point
      :x="(current.stampX2 + current.positionX) * scale"
      :y="(current.stampY2 + current.positionY) * scale"
      @x="(v) => (current.stampX2 = (v - current.positionX) / scale)"
      @y="(v) => (current.stampY2 = (v - current.positionY) / scale)"
    />
    <point
      :x="(current.stampX3 + current.positionX) * scale"
      :y="(current.stampY3 + current.positionY) * scale"
      @x="(v) => (current.stampX3 = (v - current.positionX) / scale)"
      @y="(v) => (current.stampY3 = (v - current.positionY) / scale)"
    />
    <point
      :x="(current.stampX4 + current.positionX) * scale"
      :y="(current.stampY4 + current.positionY) * scale"
      @x="(v) => (current.stampX4 = (v - current.positionX) / scale)"
      @y="(v) => (current.stampY4 = (v - current.positionY) / scale)"
    />
  </mask-matrix>
</template>

<script>
import Point from "./point/Point.vue";
import MaskMatrix from "./mask-matrix/MaskMatrix.vue";

export default {
  components: { Point, MaskMatrix },
  props: {
    current: Object,
    scale: Number,
    previewWidth: Number,
    previewHeight: Number,
  },
  data() {
    return {
      available: false,
    };
  },
  computed: {
    style() {
      const { previewWidth, previewHeight, scale } = this;
      return {
        backgroundImage: `url(${this.current.previewMask.src})`,
        width: `${previewWidth * scale}px`,
        height: `${previewHeight * scale}px`,
      };
    },
  },
  methods: {
    setPoints(width, height) {
      if (
        this.current.stampX1 === null ||
        this.current.stampY1 === null ||
        this.current.stampX2 === null ||
        this.current.stampY2 === null ||
        this.current.stampX3 === null ||
        this.current.stampY3 === null ||
        this.current.stampX4 === null ||
        this.current.stampY4 === null
      ) {
        this.current.stampX1 = 0;
        this.current.stampY1 = 0;
        this.current.stampX2 = width;
        this.current.stampY2 = 0;
        this.current.stampX3 = 0;
        this.current.stampY3 = height;
        this.current.stampX4 = width;
        this.current.stampY4 = height;
      }
      this.available = true;
    },
  },
  mounted() {
    this.setPoints(this.previewWidth, this.previewHeight);
  },
};
</script>

<style lang="scss" scoped></style>
